"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PathTemplate_1 = require("./PathTemplate");
var isFunction = require("lodash.isfunction");
var isString = require("lodash.isstring");
var notFoundHandler = function (req) {
    return Promise.reject({ code: "NOT_FOUND", request: req, message: "Unable to find handler for " + req.path });
};
var uselessRouter = {
    handleRequest: function (req, next) {
        return Promise.resolve(next ? next(req) : notFoundHandler(req));
    }
};
var RequestHandlerRouter = /** @class */ (function () {
    function RequestHandlerRouter(requestHandler) {
        this._requestHandler = requestHandler;
    }
    RequestHandlerRouter.prototype.handleRequest = function (req, next) {
        return Promise.resolve(this._requestHandler(req, next));
    };
    return RequestHandlerRouter;
}());
var createRouter = function (router) {
    if (isFunction(router)) {
        return new RequestHandlerRouter(router);
    }
    return router ? router : uselessRouter;
};
var PathRouter = /** @class */ (function () {
    function PathRouter(path, router) {
        this._pathTemplate = new PathTemplate_1.PathTemplate(path, { end: false });
        this._router = createRouter(router);
    }
    PathRouter.prototype.handleRequest = function (req, next) {
        if (next === void 0) { next = notFoundHandler; }
        var testPath = req.basePath ? req.path.substring(req.basePath.length) : req.path;
        var testResult = this._pathTemplate.test(testPath);
        if (testResult.match) {
            var handlerReq = Object.assign({}, req);
            handlerReq.params = Object.assign({}, req.params, testResult.params);
            var matchedPath = this._pathTemplate.toPath(handlerReq.params);
            handlerReq.basePath = req.basePath ? req.basePath + matchedPath : matchedPath;
            return this._router.handleRequest(handlerReq, next);
        }
        next();
    };
    return PathRouter;
}());
var Router = /** @class */ (function () {
    function Router() {
        this._routers = [];
    }
    Router.prototype.use = function (pathOrRouter, router) {
        var r;
        if (isString(pathOrRouter)) {
            r = new PathRouter(pathOrRouter, router);
        }
        else {
            r = createRouter(pathOrRouter);
        }
        this._routers.push(r);
    };
    Router.prototype._processRouter = function (router, context, next) {
        return Promise.resolve(router.handleRequest(context.request, next)).then(function (value) {
            if (!context.next) {
                context.value = value;
            }
        });
    };
    Router.prototype._nextRouterHandler = function (router, context, next) {
        var _this = this;
        return function () {
            if (context.next) {
                context.next = false;
                return _this._processRouter(router, context, next);
            }
            return Promise.resolve();
        };
    };
    Router.prototype.handleRequest = function (req, next) {
        var _this = this;
        if (next === void 0) { next = notFoundHandler; }
        var fallThrough = function (req) {
            return _this.defaultHandler ? _this.defaultHandler(req, next) : next(req);
        };
        var context = {
            request: req,
            next: false
        };
        var nextInternal = function (request) {
            if (request) {
                context.request = request;
            }
            context.next = true;
        };
        var p;
        this._routers.forEach(function (r) {
            if (!p) {
                p = _this._processRouter(r, context, nextInternal);
            }
            else {
                p = p.then(_this._nextRouterHandler(r, context, nextInternal));
            }
        });
        if (!p) {
            p = Promise.resolve(fallThrough(context.request));
        }
        else {
            p = p.then(function () {
                if (context.next) {
                    return Promise.resolve(fallThrough(context.request));
                }
                return context.value;
            });
        }
        return p;
    };
    return Router;
}());
exports.Router = Router;
